import React from "react";
class Dashboard extends React.Component {
  render() {
    return(
      <>
        <div>
            This is Admin Dashboard
        </div>
      </>
    );
  }
}
export default Dashboard;